import * as actions_notifications from 'actions/notifications-actions';
import NotificationItem from "./notification_item";
import React from "react";
import { ModalForm } from "enspire-manager-framework";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

/**
 * AllNotificationsModal component.
 * 
 * Displays a paginated list of all notifications.
 * 
 * @param { Object } props - Component props
 * @param { Function } props.hideModalCallback - Callback function when closing modal
 * @returns 
 */
export default function AllNotificationsModal({ 
    hideModalCallback,
}) {

    const params = useParams()
    const dispatch = useDispatch()
    
    const notifications = useSelector(store => store.notifications.notifications)
    const unread_notifications = notifications.filter(notification => !notification.read);
    const read_notifications = notifications.filter(notification => notification.read);

    const clearAllNotifications = () => {
        dispatch(actions_notifications.clearAllUnreadNotifications(params.handle, [...unread_notifications]))
    }
    
    return (

        <ModalForm
			bodyClassName={'px-1'}
            size={'lg'}
            modal_header={<span className="text-dark"><i class="fa fa-envelope fa-lg mr-2" aria-hidden="true"></i> All Notifications</span>}
            hide_cancel={ false }
            cancel_button_callback={hideModalCallback}
            cancel_button_title={'Close'}
            save_button_title={'Clear All Unread'}
            submitFormHandler={ clearAllNotifications }
        >
            <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                { unread_notifications.length > 0 &&
                    <div className="d-flex justify-content-center text-uppercase font-weight-bold py-2 border bg-warning mb-2 sticky-top">
                        Unread Notifications
                    </div>
                }
                { unread_notifications?.map((notification, index) => 
                    <NotificationItem 
                        key={`${index}-${notification.subject}`}
                        lastIndex={index === unread_notifications.length - 1}
                        hideModalCallback={hideModalCallback}
                        { ...notification } 
                    />
                )}
                { read_notifications.length > 0 &&
                    <div className="d-flex justify-content-center text-uppercase font-weight-bold py-2 border bg-secondary text-white mb-2 sticky-top">
                        Read Notifications
                    </div>
                }
                { read_notifications?.map((notification, index) => 
                    <NotificationItem 
                        key={`${index}-${notification.subject}`}
                        lastIndex={index === read_notifications.length - 1}
                        hideModalCallback={hideModalCallback}
                        { ...notification } 
                    />
                )}
            </div>
        </ModalForm>
    )
}